import React from "react"

const Overlay = ({ ...props }) => {
  return (
    <div
      {...props}
      style={{
        position: "fixed",
        right: 0,
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 10,
      }}
    ></div>
  )
}

export default Overlay
